// removed by extract-text-webpack-plugin
module.exports = {"List":"_1rohrNBQMr6IXHYCKJwdfP","Header":"_1AY6jjSP4nHavssa830qrF","green":"_3KAuUDVdKtCpoqgZWPeg7D","red":"_3FHrw_tVyaTiZ2fCPu86Xo","Row":"_2Mt-KGBi8oNuS-ThDLx4ly"};


//////////////////
// WEBPACK FOOTER
// ./src/lists/DivisionsList/index.css
// module id = 951
// module chunks = 0